import { Alert, SocialMediaIcon, SocialMediaIconProps } from '@kontentino/ui';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';
import PageTypeUtils from 'app/utils/pageType';
import { FC } from 'react';
import { PageData } from 'types/Page';
import { useTranslation } from 'react-i18next';

type Props = {
  page: PageData | undefined;
  projectName?: string;
  additionalMessage?: string;
  errorMessage: string;
};

const ShiftTargetUnsuccessful: FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <div className="tw-mt-3">
      <Alert variant="danger">
        <div className="tw-flex tw-items-center">
          <p>{props.errorMessage}&nbsp;</p>
          {props.page && (
            <SocialMediaIcon
              type={
                PageTypeUtils.getName(
                  props.page.type,
                ) as SocialMediaIconProps['type']
              }
              size={getYtLogoGuidelineSize(14, props.page.type)}
            />
          )}
          <div className="tw-ml-1 tw-font-bold">
            {props.page?.name ?? t('unknownPage')}
          </div>
        </div>
        <div className="tw-flex tw-items-center">
          {t('postsShift.toContentPlan')}: &nbsp;
          <div className="tw-flex">
            {props.projectName ?? t('unknownContentPlan')}
          </div>
        </div>
        {props.additionalMessage && (
          <div className="tw-mt-1">{props.additionalMessage}</div>
        )}
      </Alert>
    </div>
  );
};

export default ShiftTargetUnsuccessful;
